import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useTranslation } from 'react-i18next';

interface WarningDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

function WarningDialog({ open, onOpenChange }: WarningDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('warning')}</DialogTitle>
        </DialogHeader>
        <div className="grid w-full gap-2 p-4">
          <div>
            {t('warning_message')}
          </div>
          <Button onClick={() => onOpenChange(false)}>{t('ok')}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default WarningDialog;
